export default __webpack_public_path__ + "static/media/spinach.8c4617bf.png";